module.exports = __webpack_public_path__ + "img/snap_03.2f46e981.png";